/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Accordion } from "react-bootstrap";
import CardSection from "../../../components/ui/card/CardSection";
import MolGrid from "../../../components/Grid/MolGrid";
import { PositionSubSkillListGridConfig } from "./PositionSubSkillList.Data";
import { AppIcons } from "../../../data/appIcons";
import Buttons from "../../../components/ui/button/Buttons";
import ConfigureSkillCategory from "./cofigureSkills/ConfigureSkillCategory";
import CenterModel from "../../../components/ui/centerModel/CenterModel";
import ConfigureMainSkill from "./cofigureSkills/ConfigureMainSkill";
import ConfigureSubSkill from "./cofigureSkills/ConfigureSubSkill";
import {
  useDeleteJobMainSkillMutation,
  useDeleteJobSkillCategoriesMutation,
  useDeleteJobSubSkillMutation,
  useLazyGetJobSkillByIdQuery,
  useUpdateSubSkillDetailsMutation,
} from "../../../app/services/skillCategoriesAPI";
import SidebarModal from "../../../components/ui/sidebarModel/SidebarModel";
import Iconify from "../../../components/FinalForms/ui/iconify/Iconify";
import SwalAlert from "../../../services/swalService/SwalService";
import ToastService from "../../../services/toastService/ToastService";
import NoRecordFound from "../../../components/ui/noRecordFound/NoRecordFound";

const ConfigureSkills = ({ positionAppliedId }) => {
  const molGridRef = useRef();
  const [listData, setListData] = useState([]);
  const mainSkillRef = useRef();
  const subSkillRef = useRef();
  const { confirm } = SwalAlert();
  const [skillCategoryModelOpen, setSkillCategoryModelOpen] = useState(false);
  const [mainSkillModelOpen, setMainSkillModelOpen] = useState(false);
  const [subSkillModelOpen, setSubSkillModelOpen] = useState(false);
  const [
    getJobSkillById,
    {
      isFetching: isGetJobSkillByIdFetching,
      isSuccess: isGetJobSkillByIdFetched,
      data: GetJobSkillByIdData,
    },
  ] = useLazyGetJobSkillByIdQuery();
  const [
    deleteJobSkillCategories,
    {
      isSuccess: isDeleteJobSkillCategoriesSuccess,
      data: isDeleteJobSkillCategoriesData,
    },
  ] = useDeleteJobSkillCategoriesMutation();
  const [
    deleteJobMainSkill,
    { isSuccess: isDeleteJobMainSkillSuccess, data: isDeleteJobMainSkillData },
  ] = useDeleteJobMainSkillMutation();
  const [
    deleteJobSubSkill,
    { isSuccess: isDeleteJobSubSkillSuccess, data: isDeleteJobSubSkillData },
  ] = useDeleteJobSubSkillMutation();
  const [
    updateSubSkillDetails,
    {
      isLoading: isUpdateSubSkillDetailsLoading,
      isSuccess: isUpdateSubSkillDetailsSuccess,
      data: isUpdateSubSkillDetailsData,
    },
  ] = useUpdateSubSkillDetailsMutation();

  useEffect(() => {
    if (positionAppliedId) {
      getJobSkillById(positionAppliedId);
    }
  }, [positionAppliedId]);

  useEffect(() => {
    if (
      !isGetJobSkillByIdFetching &&
      isGetJobSkillByIdFetched &&
      GetJobSkillByIdData
    ) {
      setListData(GetJobSkillByIdData);
    }
  }, [
    isGetJobSkillByIdFetching,
    isGetJobSkillByIdFetched,
    GetJobSkillByIdData,
  ]);

  const handleSkillCategory = () => {
    setSkillCategoryModelOpen(!skillCategoryModelOpen);
  };

  const refreshGrid = () => {
    getJobSkillById(positionAppliedId);
  };

  const handleMainSkill = (id) => {
    setMainSkillModelOpen(!mainSkillModelOpen);
    if (mainSkillRef.current) {
      mainSkillRef.current.getMainSkillCategoryId(id);
    }
  };
  const handleSubSkill = (subSkillId) => {
    setSubSkillModelOpen(!subSkillModelOpen);
    if (subSkillRef.current) {
      subSkillRef.current.getSubSkillCategoryId(subSkillId);
    }
  };

  const onSidebarClose = () => {
    setSkillCategoryModelOpen(false);
    setMainSkillModelOpen(false);
    setSubSkillModelOpen(false);
  };
  useEffect(() => {
    if (isUpdateSubSkillDetailsSuccess && isUpdateSubSkillDetailsData) {
      refreshGrid();
      ToastService.success(isUpdateSubSkillDetailsData.errorMessage);
    }
  }, [isUpdateSubSkillDetailsSuccess && isUpdateSubSkillDetailsData]);

  useEffect(() => {
    if (isDeleteJobSubSkillSuccess && isDeleteJobSubSkillData) {
      getJobSkillById(positionAppliedId);
      ToastService.success(isDeleteJobSubSkillData.errorMessage);
    }
  }, [isDeleteJobSubSkillSuccess, isDeleteJobSubSkillData]);

  useEffect(() => {
    if (isDeleteJobMainSkillSuccess && isDeleteJobMainSkillData) {
      getJobSkillById(positionAppliedId);
      ToastService.success(isDeleteJobMainSkillData.errorMessage);
    }
  }, [isDeleteJobMainSkillData, isDeleteJobMainSkillSuccess]);

  useEffect(() => {
    if (isDeleteJobSkillCategoriesSuccess && isDeleteJobSkillCategoriesData) {
      getJobSkillById(positionAppliedId);
      ToastService.success(isDeleteJobSkillCategoriesData.errorMessage);
    }
  }, [isDeleteJobSkillCategoriesSuccess, isDeleteJobSkillCategoriesData]);

  const handleDeleteClick = (
    data,
    skillCategoriesMainSkillsId,
    positionAppliedId,
    positionAppliedSkillCategoriesId
  ) => {
    
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        
        if (data) {
          const request = {
            positionAppliedId: data.positionAppliedId,
            mainSkillsSubSkillsId: data.mainSkillsSubSkillsId,
          };
          deleteJobSubSkill(request);
        } else if (skillCategoriesMainSkillsId) {
          const request = {
            positionAppliedId: positionAppliedId,
            skillCategoriesMainSkillsId: skillCategoriesMainSkillsId,
          };
          deleteJobMainSkill(request);
        } else if (positionAppliedSkillCategoriesId) {
          const request = {
            positionAppliedId: positionAppliedId,
            positionAppliedSkillCategoriesId: positionAppliedSkillCategoriesId,
          };
          deleteJobSkillCategories(request);
        }
      }
    });
  };

  const handleCheckBoxClick = (data, field, checked) => {
    const request = {
      mainSkillsSubSkillsId: data.mainSkillsSubSkillsId,
      isSubSkillRequired: checked,
    };
    updateSubSkillDetails(request);
  };

  const actionHandler = {
    DELETE: handleDeleteClick,
    CHECKBOX: handleCheckBoxClick,
  };
  return (
    <>
      <div>
        <div className="d-flex justify-content-end">
          <Buttons
            imagePath={AppIcons.addIcon}
            buttonTypeClassName="theme-btn m-2"
            onClick={handleSkillCategory}
            buttonText="Add Skill Category"
          />
        </div>
        {listData.length > 0 ? (
          <>
            {listData.map((skillcategoryItem) => (
              <React.Fragment key={skillcategoryItem.positionAppliedId}>
                <CardSection
                  cardTitle={skillcategoryItem.skillCategoriesName}
                  rightButton={true}
                  buttonClassName="btn delete-btn"
                  textWithIcon={true}
                  titleButtonClick={() =>
                    handleDeleteClick(
                      null,
                      null,
                      skillcategoryItem.positionAppliedId,
                      skillcategoryItem.positionAppliedSkillCategoriesId
                    )
                  }
                  iconImg={AppIcons.deleteIcon}
                >
                  <div className="position-skill-table">
                    <div className="d-flex justify-content-end">
                      <Buttons
                        imagePath={AppIcons.addIcon}
                        buttonTypeClassName="theme-btn m-2"
                        onClick={() =>
                          handleMainSkill(skillcategoryItem.skillCategoriesId)
                        }
                        buttonText="Add Main Skill"
                      />
                    </div>
                    {skillcategoryItem.mainSkillList.map(
                      (mainSkillItem, index) => (
                        <Accordion defaultActiveKey={index}>
                          <Accordion.Item>
                            <Accordion.Header>
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <div className="d-flex justify-content-end btn-sec mr-3">
                                  <Iconify
                                    icon={"ic:outline-delete"}
                                    className="theme-btn delete-btn mr-2"
                                    altText={"Delete"}
                                    onClick={() =>
                                      handleDeleteClick(
                                        null,
                                        mainSkillItem.skillCategoriesMainSkillsId,
                                        skillcategoryItem.positionAppliedId
                                      )
                                    }
                                  />
                                  <div>{mainSkillItem.mainSkillName}</div>
                                </div>

                                <Buttons
                                  imagePath={AppIcons.addIcon}
                                  buttonTypeClassName="add-sub-btn mr-2"
                                  onClick={() =>
                                    handleSubSkill(mainSkillItem.mainSkillId)
                                  }
                                  buttonText="Add Sub Skill"
                                />
                              </div>
                            </Accordion.Header>

                            <Accordion.Body>
                              <div className="slikk-table">
                                <div className="table-body-scroll">
                                  <MolGrid
                                    ref={molGridRef}
                                    configuration={
                                      PositionSubSkillListGridConfig
                                    }
                                    dataSource={mainSkillItem.subSkillList}
                                    allowPagination={false}
                                    onActionChange={actionHandler}
                                    isLoading={isUpdateSubSkillDetailsLoading || isGetJobSkillByIdFetching}
                                  />
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      )
                    )}
                  </div>
                </CardSection>
              </React.Fragment>
            ))}
          </>
        ) : (
          <NoRecordFound />
        )}
      </div>
      <SidebarModal
        modalTitle="Main Skill"
        modalSize="w-35"
        onClose={onSidebarClose}
        isOpen={mainSkillModelOpen}
      >
        <ConfigureMainSkill
          isOpen={mainSkillModelOpen}
          onClose={onSidebarClose}
          mainSkillRef={mainSkillRef}
          positionAppliedId={positionAppliedId}
          refreshGrid={refreshGrid}
        />
      </SidebarModal>

      <CenterModel
        showModal={skillCategoryModelOpen}
        handleToggleModal={handleSkillCategory}
        modalTitle="SKill Category"
        modelSizeClass="w-40"
      >
        <ConfigureSkillCategory
          positionAppliedId={positionAppliedId}
          refreshGrid={refreshGrid}
          isOpen={skillCategoryModelOpen}
          onClose={onSidebarClose}
        />
      </CenterModel>

      <SidebarModal
        modalTitle="Sub Skill"
        modalSize="w-35"
        onClose={onSidebarClose}
        isOpen={subSkillModelOpen}
      >
        <ConfigureSubSkill
          isOpen={mainSkillModelOpen}
          onClose={onSidebarClose}
          refreshGrid={refreshGrid}
          subSkillRef={subSkillRef}
          positionAppliedId={positionAppliedId}
        />
      </SidebarModal>
    </>
  );
};
export default ConfigureSkills;
